import axios from "axios";
import { API_PATH } from "../environments";
const apiClient = axios.create({
    baseURL:`${API_PATH}`,
  // baseURL: "http://localhost:8085/api",
  //baseURL: "https://DevopsSre.sandhata.com/api",
  // baseURL: "https://devopssrescoreportal.sandhata.com/api",
  timeout: 100000,
  withCredentials:true,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const normalizedError = error.response?.data || error.message;
    return Promise.reject(normalizedError);
  },
);

export default apiClient;
